import React from 'react';

const factors = [
  'El miedo al rechazo o la invalidación',
  'La presión familiar o social',
  'La vergüenza aprendida y la culpa',
  'El estrés por ocultarte o "explicarte" constantemente',
  'Experiencias de discriminación, violencia o exclusión',
  'Heridas en vínculos, autoestima o sentido de pertenencia',
];

export default function LGTBIQASection() {
  return (
    <section id="lgtbiqa" className="section-padding bg-[var(--color-inerva-forest)]">
      <div className="container-narrow">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block text-sm font-medium tracking-widest text-[var(--color-inerva-cream)] opacity-70 mb-4 uppercase">
            Espacio seguro
          </span>
          <h2 className="text-[var(--color-inerva-cream)] mb-6">Enfoque LGTBIQA+ afirmativo</h2>

          <div className="space-y-5 text-cream-80">
            <p>
              En Inerva ofrecemos un acompañamiento LGTBIQA+ afirmativo, lo que significa que tu identidad,
              tu orientación y tu forma de vivir el género no se cuestionan ni se interpretan como un problema.
            </p>
            <p>
              Sabemos que muchas personas del colectivo han tenido experiencias previas en terapia donde se han
              sentido juzgadas, invisibilizadas o no comprendidas. Por eso cuidamos especialmente el lenguaje,
              la seguridad emocional y el respeto profundo por tu vivencia.
            </p>

            <p className="font-medium text-[var(--color-inerva-cream)]">
              También entendemos que el malestar puede estar relacionado con factores como:
            </p>

            <ul className="space-y-3">
              {factors.map((f, i) => (
                <li key={i} className="flex items-start gap-3">
                  <svg className="w-5 h-5 text-[var(--color-inerva-mint)] mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <p>
              Acompañamos procesos como: autoaceptación, exploración de identidad, relaciones, límites, duelo,
              ansiedad, trauma, vínculos familiares, y construcción de una vida propia.
            </p>

            <p className="text-[var(--color-inerva-cream)] font-medium pt-4">
              No necesitas encajar. En Inerva trabajamos para que puedas vivir con más libertad interna,
              seguridad y coherencia contigo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
